/*
 * Garnfarben-Raster - Dawn 15.5.0 extension.
 *
 * Im picker-Modus ist die Auswahl standardmaessig eingeklappt hinter einem
 * Trigger-Button (wie ein Dropdown). Klick oeffnet das Panel mit allen 84
 * Spulen (scrollbar), Klick auf eine Spule waehlt sie und klappt automatisch
 * wieder zu. Das <select> bleibt im DOM als Fallback/Pflichtfeld-Traeger.
 */

if (!customElements.get('garn-grid')) {
  class GarnGrid extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.picker = this.dataset.garnMode === 'picker';
      this.items = Array.from(this.querySelectorAll('.garn__item'));
      this.select = this.querySelector('[data-garn-select]');
      this.fallback = this.querySelector('[data-garn-fallback]');
      this.trigger = this.querySelector('[data-garn-trigger]');
      this.triggerSwatch = this.querySelector('[data-garn-trigger-swatch]');
      this.triggerText = this.querySelector('[data-garn-trigger-text]');
      this.panel = this.querySelector('[data-garn-panel]');

      this.items.forEach((item, index) => {
        item.addEventListener('click', () => this.choose(index));
        if (this.picker) item.addEventListener('keydown', (e) => this.onKey(e, index));
      });

      if (!this.picker) return;

      if (this.fallback) this.fallback.classList.add('is-hidden');

      if (this.trigger) {
        this.trigger.addEventListener('click', () => this.toggle());
      }

      document.addEventListener('click', (event) => {
        if (!this.panel || this.panel.hidden) return;
        if (this.contains(event.target)) return;
        this.close();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.panel && !this.panel.hidden) this.close();
      });

      if (this.select) {
        this.select.addEventListener('change', () => this.syncFromSelect());
        this.syncFromSelect();
      }
    }

    toggle() {
      if (!this.panel) return;
      if (this.panel.hidden) this.open();
      else this.close();
    }

    open() {
      if (!this.panel) return;
      this.panel.hidden = false;
      if (this.trigger) this.trigger.setAttribute('aria-expanded', 'true');
    }

    close() {
      if (!this.panel) return;
      this.panel.hidden = true;
      if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');
    }

    choose(index) {
      const item = this.items[index];
      if (!item) return;

      if (!this.picker) {
        this.items.forEach((el) => el.removeAttribute('aria-current'));
        item.setAttribute('aria-current', 'true');
        return;
      }

      if (this.select) {
        this.select.disabled = false;
this.select.value = item.dataset.garnValue;
this.select.dispatchEvent(new Event('change', { bubbles: true }));
        this.select.value = item.dataset.garnValue;
        this.select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.syncFromSelect();
      this.close();
      if (this.trigger) this.trigger.focus();
    }

    syncFromSelect() {
      if (!this.select) return;
      const value = this.select.value;

      this.items.forEach((item) => {
        const on = item.dataset.garnValue === value;
        item.setAttribute('aria-checked', String(on));
        item.tabIndex = on ? 0 : -1;
      });

      const active = this.items.find((item) => item.dataset.garnValue === value);

      if (!active) {
        if (this.items[0]) this.items[0].tabIndex = 0;
        if (this.triggerText) this.triggerText.textContent = 'Bitte wählen';
        if (this.triggerSwatch) this.triggerSwatch.hidden = true;
        return;
      }

      if (this.triggerText) this.triggerText.textContent = active.dataset.garnValue;
      if (this.triggerSwatch) {
        this.triggerSwatch.style.backgroundColor = active.dataset.garnHex;
        this.triggerSwatch.hidden = false;
      }
    }

    onKey(event, index) {
      const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key];
      if (!step) return;

      event.preventDefault();
      const next = (index + step + this.items.length) % this.items.length;
      this.items[next].focus();
    }
  }

  customElements.define('garn-grid', GarnGrid);
}